export const HowToVideo = ({ id, title, className = "" }) => (
  <figure className={className}>
    <video controls preload="none" playsInline poster={`/videos/${id}-guide.jpg`} src={`/videos/${id}-guide.mp4`} aria-label={title}
      className="w-full border-2 border-slate-900 bg-slate-900 shadow-[6px_6px_0_0_#0f172a]" data-testid={`howto-video-${id}`} />
    <figcaption className="mt-3 text-xs font-semibold text-slate-500">{title} · with voice-over and captions</figcaption>
  </figure>
);
